export default "__VITE_PUBLIC_ASSET__c776f4a7__"